import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const TRANSFERS_API_PATH = '/api/transfers';

const createTransfer = async (transferData) => {
  const response = await axios.post(`${API_BASE_URL}${TRANSFERS_API_PATH}`, transferData);
  return response.data.data;
};

const getTransfers = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${TRANSFERS_API_PATH}`, { params });
  return response.data;
};

const getTransferById = async (transferId) => {
  const response = await axios.get(`${API_BASE_URL}${TRANSFERS_API_PATH}/${transferId}`);
  return response.data.data;
};

const getTransferStoreOptions = async () => {
  const response = await axios.get(`${API_BASE_URL}${TRANSFERS_API_PATH}/options/stores`);
  return response.data.data;
};

const updateTransferStatus = async (transferId, status) => {
  // The axios interceptor will automatically add the user's active storeId to the body
  const response = await axios.put(`${API_BASE_URL}${TRANSFERS_API_PATH}/${transferId}/status`, { status });
  return response.data.data;
};

// --- ADD THIS NEW FUNCTION ---
const receiveTransfer = async (transferId, reconciliationData) => {
  const response = await axios.post(`${API_BASE_URL}${TRANSFERS_API_PATH}/${transferId}/receive`, reconciliationData);
  return response.data.data;
};

// --- ADD THIS NEW FUNCTION TO THE SERVICE OBJECT ---
const reconcileDiscrepancy = async (transferId) => {
  const response = await axios.post(`${API_BASE_URL}${TRANSFERS_API_PATH}/${transferId}/reconcile`);
  return response.data;
};

const transfersService = {
  createTransfer,
  getTransfers,
  getTransferById,
  getTransferStoreOptions,
  updateTransferStatus,
  receiveTransfer,
  reconcileDiscrepancy, // <-- EXPORT THE NEW FUNCTION
};

export default transfersService;
